export default "__VITE_ASSET__CjJKpaO0__"